<script>
export default {
    props: {
        value: {},
        min: {
            default: 1
        }
    },
    methods: {
        change(e) {
            let intValue = Math.abs(parseInt(e.target.value))
            if (intValue != intValue || intValue < this.min) {
                intValue = this.min
            } 
            e.target.value = intValue
            this.$emit('input', intValue)
        },
        minus() {
            if (this.value > this.min) {
                this.$emit('input', this.value - 1)
            }
        },
        plus() {
            this.$emit('input', this.value + 1)
        }
    }
}
</script>

<template>
    <div class="CountInput" >
        <div class="btn minus" @click="minus" ></div>
        <input autocomplete="false" type="text" :value="value" @change="change" >
        <div class="btn plus" @click="plus" ></div>
    </div>
</template>

<style lang="scss" scoped>
.CountInput {
    width: 153px;
    height: 40px;
    background:rgba(255,255,255,1);
    border-radius:4px;
    border:1px solid rgba(220,223,230,1);
    overflow: hidden;
    display: flex;
    input {
        width: 0px;
        flex-grow: 1;
        outline: none;
        border: none;
        color:rgba(96,98,102,1);
        text-align: center;
        font-size: 14px;
    }
    .btn {
        width: 40px;
        background:rgba(245,247,250,1);
        cursor: pointer;
        background-position: center;
        background-repeat: no-repeat;
    }
    .minus {
        border-right:1px solid rgba(216,220,230,1);
        background-image: url('~@/assets/count_input_minus.svg');
    }
    .plus {
        border-left:1px solid rgba(216,220,230,1);
        background-image: url('~@/assets/count_input_plus.svg');
    }
}
</style>





// WEBPACK FOOTER //
// src/components/common/CountInput.vue